import React, {Component} from 'react';
import './styles.css';
import CardHelper from "../../helpers";
import { getCoverStyle, isPS4Platform, clearCoverRef } from '../ps4ImageUtils';

const _isPS4 = isPS4Platform();

class CardHighlight extends Component {
  constructor(props) {
    super(props);
    this.state = { imageReady: !_isPS4 };
    this._coverRef = null;
    this._loadTimer = null;

    this._setCoverRef = this._setCoverRef.bind(this);

    // Cache de elementos JSX
    this._cachedProgressBar = null;
    this._cachedBadge = null;
    this._cachedCoverStyle = null;

    // Cache de valores previos
    this._prevBookmark = undefined;
    this._prevBadges = undefined;
    this._prevCover = undefined;
    this._prevImageReady = undefined;
  }

  componentDidMount() {
    if (!this.state.imageReady) {
      this._loadTimer = setTimeout(this._onImageReady, _isPS4 ? 200 : 150);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.cover !== nextProps.cover ||
      this.props.bookmark !== nextProps.bookmark ||
      this.props.badges !== nextProps.badges ||
      this.props.classOutLineFocus !== nextProps.classOutLineFocus ||
      this.state.imageReady !== nextState.imageReady
    );
  }

  componentWillUnmount() {
    if (this._loadTimer) {
      clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
    clearCoverRef(this._coverRef);
    this._coverRef = null;
    this._cachedProgressBar = null;
    this._cachedBadge = null;
    this._cachedCoverStyle = null;
  }

  _onImageReady = function() {
    this.setState({ imageReady: true });
  }.bind(this);

  _setCoverRef(el) {
    this._coverRef = el;
  }

  _updateCachedElements() {
    const bookmark = this.props.bookmark;
    const badges = this.props.badges;
    const cover = this.props.cover;
    const imageReady = this.state.imageReady;

    if (bookmark !== this._prevBookmark) {
      this._prevBookmark = bookmark;
      this._cachedProgressBar = CardHelper.createProgressBar(bookmark);
    }

    if (badges !== this._prevBadges) {
      this._prevBadges = badges;
      this._cachedBadge = CardHelper.createBadge(badges);
    }

    if (cover !== this._prevCover || imageReady !== this._prevImageReady) {
      this._prevCover = cover;
      this._prevImageReady = imageReady;
      this._cachedCoverStyle = getCoverStyle(cover, imageReady);
    }
  }

  render() {
    this._updateCachedElements();

    const cover = this.props.cover;
    const classOutLineFocus = this.props.classOutLineFocus;

    return (
      <div className={'card card-highlight ' + (classOutLineFocus || '')}>
        <div className={'card-container'}>
          <div className={'preview-container'}>
            {cover !== '' &&
            <div
              ref={this._setCoverRef}
              className='card-cover'
              style={this._cachedCoverStyle}
            />
            }
            {this._cachedProgressBar}
            {this._cachedBadge}
          </div>
        </div>
      </div>
    );
  }
}

export default CardHighlight;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardHighlight/index.js